//
import $ from 'jquery';
import config from './../../../config';

export function get_leave_summary( user_id ){
	return dispatch => {

		$.ajax({
			method: 'GET',
            url: config.apiurl + 'reports/',
            data: {
				method: 'GET_LEAVE_SUMMARY',
				user_id: user_id
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_LEAVE_SUMMARY",
				reports: response
			});
		});

	}
}

// Get Company
export function get_company(){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'employee/',
			data: {
                method: 'GET_EMPLOYEE_COMPANY',
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_COMPANY_SUMMARY",
				reports: response
			})
		})

	}
}

// Get Department
export function get_department(){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'employee.edit/',
			data: {
                method: 'GET_DEPARTMENT_EDIT',
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_DEPARTMENT_SUMMARY",
				reports: response
			})
		})

	}
}


// WEBPACK FOOTER //
// ./src/pages/reports/actions/reports.action.js